import request from 'common/request';
import ACTION_ITEMS from '../actionItems';

export function selfAssessmentCheckIfDone() {
  return (dispatch) => {
    request.get('/self-profile/checkIfDone')
      .then(function (response) {
        const { redirect, isDone } = response.data;
        if (redirect) {
          window.location = './login';
        } else {
          dispatch(selfAssessmentCheckIfDoneSuccess(isDone));
        }
      }).catch(function (error) {
        console.error(error);
      });
  };
};

function selfAssessmentCheckIfDoneSuccess(isDone) {
  return {
    type: ACTION_ITEMS.NAVBAR.SELF_DONE.SET,
    payload: {
      isDone
    }
  };
};



// WEBPACK FOOTER //
// ./src/components/navbar/actions/selfAssessmentCheckIfDone.js